import { DefaultPromotion, ScheduleFallbackMode } from './types'
import { GlobalPromotionMode } from '@storefronts/common-types'

export function fallbackModeFromGlobal(
    mode: GlobalPromotionMode,
): ScheduleFallbackMode {
    if (mode === 'DISABLED') return 'DISABLED'
    if (mode === 'AUTO_SYNC') return 'AUTO_SYNC'
    return 'MANUAL'
}

export function globalModeFromDefault(
    defaultPromotion: DefaultPromotion,
): GlobalPromotionMode {
    if (defaultPromotion.kind === 'AUTO_SYNC') return 'AUTO_SYNC'
    if (defaultPromotion.kind === 'DISABLED') return 'DISABLED'
    return 'MANUAL'
}

export function defaultPromotionName(
    defaultPromotion: DefaultPromotion,
    syncedName?: string | null,
): string {
    if (defaultPromotion.kind === 'SPECIFIC') {
        return defaultPromotion.promotion.name
    }
    if (defaultPromotion.kind === 'AUTO_SYNC') {
        return syncedName
            ? `Sync with my website · ${syncedName}`
            : 'Sync with my website'
    }
    if (defaultPromotion.kind === 'UNSET') return 'No default selected'
    return 'No promotion'
}

export function defaultPromotionShortName(
    defaultPromotion: DefaultPromotion,
): string {
    if (defaultPromotion.kind === 'SPECIFIC') {
        return defaultPromotion.promotion.name
    }
    if (defaultPromotion.kind === 'AUTO_SYNC') return 'Sync with my website'
    if (defaultPromotion.kind === 'UNSET') return 'No default selected'
    return 'No promotion'
}

export function defaultPromotionExplanation(
    defaultPromotion: DefaultPromotion,
): string {
    switch (defaultPromotion.kind) {
        case 'AUTO_SYNC':
            return 'Show whatever promotion is live on your site.'
        case 'DISABLED':
            return 'Storefronts show full price.'
        case 'UNSET':
            return 'Choose what runs when nothing is scheduled.'
        case 'SPECIFIC':
            return 'Always-on offer on storefronts.'
    }
}
